import error from './error'

export default {
  lang: {
    code: 'es',
    name: 'Español'
  },
  nav: {
    minting: 'Minteo',
    collection: 'Colección',
    portfolio: 'Mi Cartera',
    changeWallet: 'Cambiar Wallet',
    disconnectWallet: 'Desconectar Wallet',
    token: 'Detalles del Token #{0}',
    provenance: 'Procedencia',
    termsAndConditions: 'Términos y Condiciones'
  },
  minting: {
    titleSale: 'Minteo',
    titlePresale: 'Minteo en Preventa',
    saleStartsSoon: 'La venta de The QBits comenzará pronto',
    setMaxTokens: 'Compra Max',
    totalPrice: 'Precio total',
    estimatedGas: 'Costo de gas estimado para Tx',
    accountBalance: 'Balance actual de cuenta',
    accountTokensBalance: 'QBits que posees',
    mintInPresale: 'Mintear en Preventa',
    mintInSale: 'Mintear QBits',
    notInPresale: 'Tu cuenta no se encuentra en la lista de preventa, por favor espera a la venta pública.'
  },
  token: {
    genericTokenTitle: 'Token # {0}',
    idOutOfBound: 'El ID del Token está fuera de rango',
    dataUnavailable: 'Información de token no disponible',
    descriptionUnavailable: 'Descripción no disponible',
    viewDetails: 'Ver Detalles',
    loadingDetails: 'Cargando detalles del token',
    owner: 'Dueño/a',
    tradeInOpenSea: 'Intercambiar token en OpenSea',
    requestHRContent: 'Obtener contenido de alta resolución',
    openHRContent: 'Abrir contenido de alta resolución',
    buyInOpenSea: 'Comprar QBits en OpenSea',
    noTokensInPortfolio: 'No tienes QBits en tu cartera.'
  },
  provenance: {
    title: 'Registro de Procedencia de The Qbits',
    descriptionLine1: 'Esta página presenta el registro de procedencia de todos Los QBits que existirán.',
    descriptionLine2: 'Cada imagen QBit se procesa primero mediante el algoritmo SHA-256. Se obtiene una cadena combinada concatenando el hash SHA-256 de cada imagen QBit en el orden específico que se indica a continuación. La prueba final se obtiene mediante el hash SHA-256 de esta cadena combinada. Este es el registro de procedencia final almacenado en el contrato inteligente.',
    importantInfoTitle: 'Información Importante',
    contractAddr: 'Dirección del contrato',
    deployedTo: 'Desplegao en',
    provenanceHash: 'Hash de procedencia',
    finalStartingIndex: 'Indíce iniciador final',
    concatenatedStringTitle: 'Cadena de Hashes Concatenados',
    provenanceTableTitle: 'Tabla de Registros de Procedencia',
    provenanceTable: {
      initialIndex: 'Índice Inicial',
      assignedId: '# de Token Asignado',
      sha256Hash: 'Hash SHA-256',
      ipfsFile: 'Archivo IPFS'
    },
    viewProvenanceFile: 'Ver Archivo de Procedencia'
  },
  footer: {
    copyright: '©2022 TheQbits. Todos los derechos reservados.',
    buildHash: 'Hash del paquete'
  },
  error404: {
    error404: 'Error 404',
    routeNotFound: 'Ruta no encontrada',
    backToCollection: 'Volver a la Colección'
  },
  shared: {
    connect: 'Conectar',
    connectWallet: 'Conectar Wallet',
    switchToEth: 'Cambiar a Red ETH',
    unique: 'Únicos',
    rare: 'Raros',
    handmade: 'Hechos a mano',
    whatYouStand: '¿Quién te representa?'
  },
  validations: {
  },
  error,
  success: {
  }
}
